export interface EventCalendar {
  uid: string;
  startDate: Date;
  endDate: Date;
  summary: string;
  description: string;
  location: string;
}

export function generateICS(event: EventCalendar) {
  const { description, endDate, location, startDate, summary, uid } = event;

  const formatDate = (date: Date) => {
    return date
      .toISOString()
      .replace(/[-:]/g, '')
      .replace(/\.\d{3}Z/, 'Z');
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${formattedStartDate}
DTSTART:${formattedStartDate}
DTEND:${formattedEndDate}
SUMMARY:${summary}
DESCRIPTION:${description}
LOCATION:${location}
END:VEVENT
END:VCALENDAR`;

  return icsContent;
}

export function generateGoogleCalendarLink(event: EventCalendar) {
  const { description, endDate, location, startDate, summary } = event;

  // Encode summary and description for URL
  const encodedSummary = encodeURIComponent(summary);
  const encodedDescription = encodeURIComponent(description);

  // Format start and end date and time
  const formattedStartDate = startDate
    .toISOString()
    .replace(/[:-]/g, '')
    .replace(/\.\d{3}Z/, 'Z');
  const formattedEndDate = endDate
    .toISOString()
    .replace(/[:-]/g, '')
    .replace(/\.\d{3}Z/, 'Z');

  // Construct Google Calendar link
  const googleCalendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${formattedStartDate}/${formattedEndDate}&text=${encodedSummary}&details=${encodedDescription}&location=${location}`;

  return googleCalendarLink;
}
